module.exports = __webpack_public_path__ + "static/media/8OLA16.770b1c95.jpg";